/* eslint-disable import/no-anonymous-default-export */
import {
    TEMPLATES
} from '../actions/types'

export default (state = [], action) => {
    switch (action.type) {
        case TEMPLATES:
            return action.payload;
        default:
            return state;
    }
}